import React, { useEffect, useState } from 'react'
import ArticleItem from './ArticleItem'

function Articles() {

    const [blogs, setBlogs] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        fetchBlogs()
    }, [])

    async function fetchBlogs() {
        setLoading(true)
        fetch('https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@imprakashraghu')
        .then(res => res.json())
        .then(response => {
            setBlogs(response.items||[])
        })
        .catch(err => console.log(err))
        .finally(() => setLoading(false))
    }

  return (
    <div className='w-full lg:w-[60%] min-h-screen py-12 lg:py-20 px-6 lg:px-20 bg-white relative lg:left-[270px]'>
        <p className='w-full text-black text-sm text-left py-2 mb-4'>
            I am not a professional blogger, I just write when I feel confident about the topic that I publish. I usually use Medium as my main blog posting site and also use Dev Community too sometimes.
        </p>
        <div className='w-full py-10 flex flex-col items-center'>
            { loading && (<p className='w-full text-center text-black py-2 text-sm'>Fetching Articles...</p>)}
            { blogs?.map(item => (
                <ArticleItem key={item?.guid} {...item} />
            ))}
        </div>
        <p onClick={() => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }} className='w-full text-right py-2 text-sm underline text-black cursor-pointer'>Back to top</p>
    </div>
  )
}

export default Articles